import { computed, Service, signal } from '@angular/core';

import { User } from '../models/user.model';

export interface UiState {
    // cererile HTTP in curs; bara de incarcare apare cat timp e cel putin una
    cereriActive: number;
    sidenavShow: boolean;
    debugShow: boolean;
    user: User | null;
    appSection: string;
    appSectionName: string;
    appSubsection: string | null;
    appSubsectionState: string | null;
    currentMedicId: string | null;
    currentMedicNume: string | null;
    isMedicSelected: boolean;
}

const initialState: UiState = {
    cereriActive: 0,
    sidenavShow: false,
    debugShow: false,
    user: null,
    appSection: 'dashboard',
    appSectionName: 'Pagina Principală',
    appSubsection: null,
    appSubsectionState: 'view',
    currentMedicId: null,
    currentMedicNume: null,
    isMedicSelected: false,
};

/** Starea interfetei: incarcare, utilizatorul logat, sectiunea curenta si medicul selectat. */
@Service()
export class UiStore {
    private readonly state = signal<UiState>(initialState);

    readonly isLoading = computed(() => this.state().cereriActive > 0);
    readonly sidenavShow = computed(() => this.state().sidenavShow);
    readonly debugShow = computed(() => this.state().debugShow);
    readonly user = computed(() => this.state().user);
    readonly appSection = computed(() => this.state().appSection);
    readonly appSectionName = computed(() => this.state().appSectionName);
    readonly appSubsection = computed(() => this.state().appSubsection);
    readonly appSubsectionState = computed(() => this.state().appSubsectionState);
    readonly currentMedicId = computed(() => this.state().currentMedicId);
    readonly currentMedicNume = computed(() => this.state().currentMedicNume);
    readonly isMedicSelected = computed(() => this.state().isMedicSelected);

    startLoading() {
        this.state.update(state => ({ ...state, cereriActive: state.cereriActive + 1 }));
    }

    stopLoading() {
        this.state.update(state => ({ ...state, cereriActive: Math.max(0, state.cereriActive - 1) }));
    }

    hideSidenav() {
        this.patch({ sidenavShow: false });
    }

    setUser(user: User) {
        this.patch({ user });
    }

    removeUser() {
        this.patch({ user: null });
    }

    setMedicId(currentMedicId: string | null) {
        this.patch({ currentMedicId, isMedicSelected: true });
    }

    removeMedicId() {
        this.patch({ currentMedicId: null, isMedicSelected: false });
    }

    setMedicNume(currentMedicNume: string) {
        this.patch({ currentMedicNume });
    }

    setAppSection(appSection: string) {
        this.patch({ appSection });
    }

    setAppSectionName(appSectionName: string) {
        this.patch({ appSectionName });
    }

    setAppSubsection(appSubsection: string | null) {
        this.patch({ appSubsection });
    }

    setAppSubsectionState(appSubsectionState: string | null) {
        this.patch({ appSubsectionState });
    }

    private patch(changes: Partial<UiState>) {
        this.state.update(state => ({ ...state, ...changes }));
    }
}
